import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "CasinoJackpotWidget" */ './CasinoJackpotWidget'),
  modules: ['./CasinoJackpotWidget'],
  loading: () => <div />
});

export default LoadableWidget;
